__turbopack_context__.v({
  "hubCard": "preferencias-module__KqzbTq__hubCard",
  "hubFade": "preferencias-module__KqzbTq__hubFade",
  "hubView": "preferencias-module__KqzbTq__hubView",
  "prefAviso": "preferencias-module__KqzbTq__prefAviso",
  "prefAvisoBtn": "preferencias-module__KqzbTq__prefAvisoBtn",
  "prefBadge": "preferencias-module__KqzbTq__prefBadge",
  "prefBadgeNo": "preferencias-module__KqzbTq__prefBadgeNo",
  "prefBadgeSi": "preferencias-module__KqzbTq__prefBadgeSi",
  "prefControl": "preferencias-module__KqzbTq__prefControl",
  "prefDato": "preferencias-module__KqzbTq__prefDato",
  "prefDesc": "preferencias-module__KqzbTq__prefDesc",
  "prefError": "preferencias-module__KqzbTq__prefError",
  "prefEstadoLinea": "preferencias-module__KqzbTq__prefEstadoLinea",
  "prefIcon": "preferencias-module__KqzbTq__prefIcon",
  "prefIntro": "preferencias-module__KqzbTq__prefIntro",
  "prefList": "preferencias-module__KqzbTq__prefList",
  "prefMain": "preferencias-module__KqzbTq__prefMain",
  "prefMeta": "preferencias-module__KqzbTq__prefMeta",
  "prefRow": "preferencias-module__KqzbTq__prefRow",
  "prefRowMuted": "preferencias-module__KqzbTq__prefRowMuted",
  "prefTitle": "preferencias-module__KqzbTq__prefTitle",
  "prefVerBtn": "preferencias-module__KqzbTq__prefVerBtn",
  "prefVerBtnPrimario": "preferencias-module__KqzbTq__prefVerBtnPrimario",
  "telCampo": "preferencias-module__KqzbTq__telCampo",
  "telError": "preferencias-module__KqzbTq__telError",
  "telFila": "preferencias-module__KqzbTq__telFila",
  "telForm": "preferencias-module__KqzbTq__telForm",
  "telIntro": "preferencias-module__KqzbTq__telIntro",
  "telLabel": "preferencias-module__KqzbTq__telLabel",
  "telNota": "preferencias-module__KqzbTq__telNota",
  "telTitulo": "preferencias-module__KqzbTq__telTitulo",
});
